// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c926eff0","455":"6534f10e","977":"5467d6b6"}[chunkId] + ".chunk.js";
};